import { render } from "./PricesView.vue?vue&type=template&id=84457320&scoped=true"
import script from "./PricesView.vue?vue&type=script&lang=js"
export * from "./PricesView.vue?vue&type=script&lang=js"

import "./PricesView.vue?vue&type=style&index=0&id=84457320&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84457320"]])

export default __exports__